let nextNCursor = null;
let nextBCursor = null;

var countNow = 1;
var url;
var canrun = 0; //1;
var runExt = 1;
var externalSearch = 0;

var display = 0;
var total = 0;
var obj = "";
var count = 0;
var countDisplay = 0;
var totalPages = 0;
var isSearch = 0;
var searchTerm, openLink, checkContainer, end, currencyUSD, priceUSD;
var noResTextShow = 0;
var loaderanimation = 1;
var displaymore = 1;
var firstRun = true;

var plusimg =
	"https://cdn.shopify.com/s/files/1/1374/2665/files/plus-white.png?v=1647587423";
var copyimg =
	"https://cdn.shopify.com/s/files/1/1374/2665/files/copy-white.png?v=1647578979";
var opentabimg =
	"https://cdn.shopify.com/s/files/1/1374/2665/files/newimg_569296.png?v=1655270008";

var currentLocation = window.location.href;

if (currentLocation.indexOf("search?q=korea-") > -1) {
	isSearch = 1;
} else {
	canrun = 1;
}

function clearProducts() {
	var products_on_page = $(".products-on-page");
	products_on_page.empty();

	nextNCursor = null;
	nextBCursor = null;
}

function setFocus() {
	$("html, body").animate(
		{
			scrollTop: $("#CollectionAjaxContent").offset().top - 200,
		},
		1000
	);
	return false;
}

function throttle(fn, delay) {
	let shouldWait = false;
	return () => {
		if (!shouldWait) {
			fn();
			shouldWait = true;
			setTimeout(() => {
				shouldWait = false;
			}, delay);
		}
	};
}

function addProductsToDom(items) {
	var products_on_page = $(".products-on-page");
	items.forEach(product => {
		const strippedTitle = product.title.replace(/(<([^>]+)>)/gi, "");
		currencyUSD = product.price;
		priceUSD = currencyUSD.toFixed(2);
		product_link = '"' + product.link + '"';
		products_on_page.append(
			'<div class="grid-item grid-product grid-con"><div class="grid-item__content"><div onclick="goLink(&#39;' +
				product.link +
				'&#39;); return false;"><a href="#" target="" class="grid-item__link"><div class="grid-product__image-wrap"><div class="grid__image-ratio grid__image-ratio--square"><img src="' +
				product.image +
				'" class="grid__image-contain lazyload"><div class="open-tab-icon"><div class="open-tab-icon__wrapper">' +
				`<svg data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25"></path>
            </svg>` +
				'</div></div></div></div><div class="grid-item__meta"><div class="grid-item__meta-main"><div class="grid-product__title"><h3>' +
				product.title +
				'</h3></div><div class="grid-item__meta-secondary"><div class="grid-product__price"><span class="grid-product__price--current">$' +
				priceUSD +
				' USD</span></div></div></div></div></a></div><div class="btnLine"><div class="hicon"><div id="btnCustomBtn" class="moe-button moe-button--primary moe-button--rounded moe-button--hover-tone" onclick="addProduct(&#39;' +
				product.link +
				"&#39;, " +
				product.price +
				", &#39;" +
				strippedTitle +
				"&#39;, &#39;" +
				product.image +
				'&#39;)">' +
				`<span class="moe-button__label moe-button__label--with-icon"><span class="moe-icon__wrapper"><svg class="moe-icon moe-icon-plus" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15"></path>
            </svg></span><span>Add To Custom Orders</span></span>` +
				'</div><div id="btnCopyLink" class="moe-button moe-button--secondary moe-button--rounded moe-button--hover-tone" onclick="copyfx(&#39;' +
				product.link +
				"&#39;, " +
				countDisplay +
				')">' +
				`<span class="moe-button__label moe-button__label--with-icon"><span class="moe-icon__wrapper"><svg class="moe-icon moe-icon-copy" data-slot="icon" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 7.5V6.108c0-1.135.845-2.098 1.976-2.192.373-.03.748-.057 1.123-.08M15.75 18H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08M15.75 18.75v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5A3.375 3.375 0 0 0 6.375 7.5H5.25m11.9-3.664A2.251 2.251 0 0 0 15 2.25h-1.5a2.251 2.251 0 0 0-2.15 1.586m5.8 0c.065.21.1.433.1.664v.75h-6V4.5c0-.231.035-.454.1-.664M6.75 7.5H4.875c-.621 0-1.125.504-1.125 1.125v12c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V16.5a9 9 0 0 0-9-9Z"></path>
            </svg></span><span>Copy Link</span></span>` +
				'</div></div></div><span class="custom-tooltip" id="custom-tooltip-' +
				countDisplay +
				'"><p>Link copied!</p></span></div></div>'
		);
		countDisplay++;
		count++;
	});
}

const getResult = async () => {
	try {
		const data = {
			q: $("#searchTermHidden").val(),
		};

		if (!data?.q) {
			return;
		}
		$("#searchloader").remove();
		$("#CollectionAjaxContent .medium-up--four-fifths").append(
			'<div id="searchloader" class="grid collection-content loader ahoo g" style="display: block;"></div>'
		);
		if (!window.MOEGoodsExternalSearchEndpoint) {
			throw new Error("External search endpoint is not configured");
		}

		let response = await fetch(
			`${window.MOEGoodsExternalSearchEndpoint}?q=${encodeURIComponent(data.q)}` +
				(nextNCursor ? `&nCursor=${nextNCursor}` : "") +
				(nextBCursor ? `&bCursor=${nextBCursor}` : ""),
			{ method: "GET", redirect: "manual" }
		);
		if (response.type === "opaqueredirect") {
			console.error("redirect detected===>", response.url);
			throw new Error("redirect detected");
		} else if (!response.ok) {
			console.error(response);
			throw new Error("Network response was not ok");
		} else {
			let results = await response.json();
			let thisTotal = Object.keys(results.items).length;
			display = results.display;
			$("#searchloader").attr("style", "display: none !important;");
			$(".displayitem").remove();
			$(".showmore1").remove();
			$(".showmore2").remove();
			if (firstRun) {
				setFocus();
				clearProducts();
				firstRun = false;
			}
			if (thisTotal > 0) {
				addProductsToDom(results.items);
				if (noResTextShow == 0) {
					if (!$("#searchloader")) {
						$("#CollectionAjaxContent .medium-up--four-fifths").append(
							'<div id="searchloader" class="grid collection-content loader ahoo g" style="display: block;"></div>'
						);
					}
				}

				$("#ExternalSearchDiv").css("display", "block");

				if (results.provider === "naver") nextNCursor = results.nextCursor;
				if (results.provider === "bunjang") nextBCursor = results.nextCursor;
			}
			total = total + thisTotal;
			$(document).prop(
				"title",
				"Search Results for " + $("#searchTermHidden").val()
			);

			if (total == 0 && noResTextShow == 0 && countDisplay == 0) {
				$(".displayitem").remove();
				$("#searchloader").attr("style", "display: none !important;");
				showNoResults();
				noResTextShow = 1;
			}

			runExt = 1;
		}
	} catch (error) {
		console.error(error);
		$("#searchloader").attr("style", "display: none !important;");
		if (total == 0 && noResTextShow == 0 && countDisplay == 0) {
			showNoResults();
			noResTextShow = 1;
		}
	}
};

const scrollListener = throttle(() => {
	if (
		window.innerHeight + window.scrollY >=
		document.body.offsetHeight - 2000
	) {
		if (isSearch == 1) {
			getResult();
		}
	}
}, 500);

window.addEventListener("scroll", scrollListener);

function loadMoreProducts() {
	canrun = 0;
	prevCount = countNow;
	countNow++;
	var currentLocation = window.location.href;

	if (currentLocation.indexOf("search?") > -1) {
		if (currentLocation.indexOf("&page=") > -1) {
			currentLocation = currentLocation.replace(
				"&page=" + prevCount,
				"&page=" + countNow
			);
		} else {
			url = currentLocation + "&page=" + countNow;
		}
	} else {
		if (currentLocation.indexOf("?") > -1) {
			url = currentLocation + "&page=" + countNow;
		} else {
			url = currentLocation + "?page=" + countNow;
		}
	}

	$(".loadingCollection").html("Loading...");

	var products_on_page = $(".products-on-page");

	$.ajax({
		url: url,
		type: "GET",
		dataType: "html",
	}).done(function (next_page) {
		var new_products = $(next_page).find(".products-on-page");

		if (new_products.html() == "") {
			$(".loadingCollection").html("");
			$("#oriSearchResultRun").val("DONE");
			runExt = 1;
			externalSearch = 1;
			canrun = 0;
		} else {
			$(".loadingCollection").html("");
			products_on_page.append(new_products.html());
			canrun = 1;
		}
	});
}

function showNoResults() {
	searchTerm = ["Lotte", "Neoflam", "Tamagotchi", "Business Proposal"];

	checkContainer = document.getElementsByClassName("openLinkIdcontainer");

	$("#noResultText").html(
		"<p>No Results Found.</p><p>You can also search in Korean characters.</p>"
	);

	$("#CollectionAjaxContentEmpty").append(
		'<div class="openLinkIdcontainer"><p style="font-weight: bold; font-size: 16px;">Popular Search Term This Week<br></p><div class="openLinkIdcenter"></div></div>'
	);

	for (let i = 0; i < searchTerm.length; i++) {
		openLink = "/search?q=" + searchTerm[i];
		$(".openLinkIdcontainer").append(
			'<p id="searchterm" style="font-size: var(--typeBaseSize);"><a id="openLinkId" href="' +
				openLink +
				'" target="_blank">' +
				searchTerm[i] +
				"</a></p>"
		);
	}

	noResTextShow = 1; //if this div is shown, no need to run it again
}

function goLink(thelink) {
	var link = thelink;
	$("#open-link").find("#go-to-link").attr("value", link);
	$("#open-link").show();
}
